import { Injectable } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

export const AIDA_WIDGET_FEATURE_FLAG = 'EXT_AIDA_WIDGET';
// One aida-widget deployment serves every environment; the flag decides where it shows.
export const AIDA_WIDGET_URL = 'https://aida-widget.vercel.app/widget/embed.js';

/**
 * Aida AI assistant (separate project `aida-widget`). Its `embed.js` mounts the floating
 * button + iframe itself and takes the iframe address from its own `src` via
 * `document.currentScript`, so it must be inserted as a plain classic script (no `type="module"`).
 * Loaded once for the whole app; flag off = no widget.
 */
@Injectable({ providedIn: 'root' })
export class AidaWidgetService {
  constructor(private featureFlagService: FeatureFlagService) {}

  load(): void {
    if (!this.featureFlagService.isEnabled(AIDA_WIDGET_FEATURE_FLAG)) {
      return;
    }
    if (document.querySelector(`script[src="${AIDA_WIDGET_URL}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = AIDA_WIDGET_URL;
    script.async = true;
    script.onerror = () => console.error('Failed to load Aida widget script:', AIDA_WIDGET_URL);
    document.body.appendChild(script);
  }
}
